define('native/viewmodels/TouchIdSetting',['knockout'], function (ko) {

    return function TouchIdSettingViewModel (touchIdSetupDialog, touchIdModel) {

        var self = this,
            usingTouchIdSubscription;

        self.isUsingDeviceTouchId = ko.observable();

        self.currentUserIsTouchIdUser = touchIdModel.currentUserIsUsingTouchId;

        self.shouldShow = touchIdModel.canConfigureTouchId;

        self.updateSetting = function () {

            if (self.isUsingDeviceTouchId()) {
                touchIdSetupDialog.show().then(function (isUsingTouchId) {
                    self.isUsingDeviceTouchId(!!isUsingTouchId);
                    touchIdModel.deviceIsUsingTouchId(!!isUsingTouchId);
                });
            } else {
                touchIdModel.deviceIsUsingTouchId(false);
            }
        };

        self.attached = function () {
            usingTouchIdSubscription = touchIdModel.deviceIsUsingTouchId
                .subscribeAndExec(function (newValue) {
                    self.isUsingDeviceTouchId(newValue);
                });
        };

        self.detached = function () {
            usingTouchIdSubscription.dispose();
        };

        self.getView = function () {
            return 'native/views/TouchIdSetting.html';
        };
    };
});


